/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataDownloadStatusEnum } from './DataDownloadStatusEnum';
import {
    DataDownloadStatusEnumFromJSON,
    DataDownloadStatusEnumFromJSONTyped,
    DataDownloadStatusEnumToJSON,
    DataDownloadStatusEnumToJSONTyped,
} from './DataDownloadStatusEnum';

/**
 * Serializer for data downloads
 * @export
 * @interface DownloadableDataPackage
 */
export interface DownloadableDataPackage {
    /**
     * 
     * @type {string}
     * @memberof DownloadableDataPackage
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof DownloadableDataPackage
     */
    owner: number;
    /**
     * 
     * @type {string}
     * @memberof DownloadableDataPackage
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadableDataPackage
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof DownloadableDataPackage
     */
    readonly uploadedAt: Date;
    /**
     * 
     * @type {DataDownloadStatusEnum}
     * @memberof DownloadableDataPackage
     */
    readonly dataDownloadStatus: DataDownloadStatusEnum;
}



/**
 * Check if a given object implements the DownloadableDataPackage interface.
 */
export function instanceOfDownloadableDataPackage(value: object): value is DownloadableDataPackage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if ((!('uploadedAt' in (value as Record<string, any>)) && !('uploaded_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadedAt'] === undefined && (value as Record<string, any>)['uploaded_at'] === undefined)) return false;
    if ((!('dataDownloadStatus' in (value as Record<string, any>)) && !('data_download_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataDownloadStatus'] === undefined && (value as Record<string, any>)['data_download_status'] === undefined)) return false;
    return true;
}

export function DownloadableDataPackageFromJSON(json: any): DownloadableDataPackage {
    return DownloadableDataPackageFromJSONTyped(json, false);
}

export function DownloadableDataPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadableDataPackage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'],
        'description': json['description'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'uploadedAt': (new Date(json['uploaded_at'])),
        'dataDownloadStatus': DataDownloadStatusEnumFromJSON(json['data_download_status']),
    };
}

export function DownloadableDataPackageToJSON(json: any): DownloadableDataPackage {
    return DownloadableDataPackageToJSONTyped(json, false);
}

export function DownloadableDataPackageToJSONTyped(value?: Omit<DownloadableDataPackage, 'id'|'uploadedAt'|'dataDownloadStatus'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'description': value['description'],
        'notes': value['notes'],
    };
}

